import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { dayjs } from "Config/dayjs";
import { observer } from "mobx-react";
import { UserName } from "Components/General/UserName";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { QAAnswerComments } from "./QAAnswerComments";
import { PreliminaryIcon } from "./PreliminaryIcon";
import { FileAttach } from "Components/General/FileAttach";

const EditIcon: React.FunctionComponent<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <div className="answer-edit" onClick={onClick}>
      <FontAwesomeIcon icon={"pencil"} fixedWidth={true} />
    </div>
  );
};

interface QAAnswerItemProps extends WithTranslation {
  preliminary: boolean;
  answer: string;
  answerId: number;
  status: API_ANSWER_STATUS;
  updated: string;
  userId: number;
  onDecline: () => void;
  onApprove: () => void;
  onEditClick: () => void;
  canFetchComments: boolean;
  isCategoryApproval: boolean;
  isApproval1: boolean;
  isApproval2: boolean;
  isNotInAllQuestionsPage: boolean;
  isSpecialist: boolean;
  canDeclineAnswer: boolean;
  canAcceptAnswer: boolean;
  attachments: API_FileAttachment[];
}

export const QAAnswerItem = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<QAAnswerItemProps> {
      get isEditable() {
        const { isApproval1, isApproval2, status, isNotInAllQuestionsPage } = this.props;
        return (
          isNotInAllQuestionsPage &&
          ((isApproval1 && status === "IN_FIRST_STAGE_APPROVAL") ||
            (isApproval2 && status === "IN_SECOND_STAGE_APPROVAL"))
        );
      }

      render() {
        const {
          answer,
          status,
          updated,
          onDecline,
          onApprove,
          userId,
          answerId,
          preliminary,
          canFetchComments,
          onEditClick,
          attachments,
          canDeclineAnswer,
          canAcceptAnswer,
          t,
        } = this.props;
        const answerClass = classNames(
          "dialog",
          { approved: status === "APPROVED" },
          { declined: status === "ANSWER_REJECTED" || status === "NOT_ACCEPTED" || status === "NOT_ADMITTED" }
        );
        return (
          <div className="dialog-wrapper">
            <div className="dialog-data">
              <span className="dialog-username">
                <FontAwesomeIcon icon={["fas", "user"]} fixedWidth={true} style={{ marginRight: 15 }} />
                <UserName id={userId} />
              </span>
              <span className="dialog-time">{dayjs(+updated).format("lll")}</span>
            </div>
            <div className={answerClass}>
              {this.isEditable && <EditIcon onClick={onEditClick} />}
              {preliminary && <PreliminaryIcon />}
              <div className="dialog-text">{answer}</div>
              {attachments && attachments.length ? (
                <div className="mb-md">
                  {attachments.map((item) => (
                    <FileAttach key={item.id} attach={item} />
                  ))}
                </div>
              ) : null}
              <QAAnswerComments canFetch={canFetchComments} answerId={answerId} />
              {canDeclineAnswer || canAcceptAnswer ? (
                <div className="dialog-actions">
                  {canDeclineAnswer && (
                    <button className="dialog-decline" onClick={onDecline}>
                      {t("Decline")}
                    </button>
                  )}
                  {canAcceptAnswer && (
                    <button className="dialog-approve" onClick={onApprove}>
                      {t("Approve")}
                    </button>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        );
      }
    }
  )
);
